import { render, staticRenderFns } from "./ExpressOrderTableUserTable.vue?vue&type=template&id=fa903faa&scoped=true"
import script from "./ExpressOrderTableUserTable.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTableUserTable.vue?vue&type=script&lang=js"
import style0 from "./ExpressOrderTableUserTable.vue?vue&type=style&index=0&id=fa903faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa903faa",
  null
  
)

export default component.exports